//My imports
import * as types from './types';

export const cartReducer = (state = {
    reduxCartActionResult: null,
    reduxCartItems: JSON.parse(localStorage.getItem("localStoragecartItems") || "[]"),
}, action) => {
    switch (action.type) {

        case types.ADD_TO_CART_REQUEST_SUCCESS:
            return {
                reduxCartActionResult: { error: false, message: types.ADD_TO_CART_REQUEST_SUCCESS_MSG },
                reduxCartItems: action.payload.reduxCartItems
            }

        case types.REMOVE_FROM_CART_SUCCESS:
            return {
                reduxCartActionResult: { error: false, message: types.REMOVE_FROM_CART_SUCCESS_MSG },
                reduxCartItems: action.payload.reduxCartItems
            }

        case types.ADD_TO_CART_REQUEST_RESET:
            return { reduxCartActionResult: null, reduxCartItems: JSON.parse(localStorage.getItem("localStoragecartItems") || "[]") };

        case types.ADD_TO_CART_REQUEST_SERVER_ERROR:
            return { reduxCartActionResult: { error: true, message: types.ADD_TO_CART_REQUEST_SERVER_ERROR_MSG } }

        case types.REMOVE_FROM_CART_ERROR:
            return { reduxCartActionResult: { error: true, message: types.REMOVE_FROM_CART_ERROR_MSG } }

        default: return state;

    }
};